import React, { useRef } from 'react';
// Import custom hooks
import useStepLogic from 'components/Form/useStepLogic';
// Import components
import Input from 'components/shared/FormElements/Input/Input';

const EventName = () => {
  const formRef = useRef(); // Used so we can keep track of the form DOM element
  const { register } = useStepLogic(formRef); // Custom hook for handling continue button (validation, errors etc)

  const label = 'Name of event';

  // Logic used to validate fields
  const fieldValidation = (name) => {
    return register({ required: `${name} is required` });
  };

  return (
    <Input
      className="wmcads-col-1 wmcads-col-sm-3-4 wmcads-col-md-1-2"
      name="EventName"
      label={label}
      fieldValidation={fieldValidation(label)}
    />
  );
};

export default EventName;
